module.exports = __webpack_public_path__ + "static/media/summit2.bedfbfbb.jpg";